import { useEffect, useRef } from 'react'

import { Procedure } from '@/utils/eventUtils'

interface IUseFetchDispatchOption {
  componentDidUpdateCondition?: boolean
  componentDidMountCondition?: boolean
}

export const useFetchDispatch = (
  effectFunction: Procedure,
  deps: any[],
  option: IUseFetchDispatchOption,
) => {
  const didMountRef = useRef(false)
  const { componentDidUpdateCondition = true, componentDidMountCondition = true } = option

  useEffect(() => {
    if (!didMountRef.current) {
      didMountRef.current = true
      if (componentDidMountCondition) {
        effectFunction()
      }

      return
    }

    if (componentDidUpdateCondition) {
      effectFunction()
    }
  }, deps) //eslint-disable-line
}
